import { render, staticRenderFns } from "./CategoryGoodsPreview.vue?vue&type=template&id=b89df5a0&scoped=true&"
import script from "./CategoryGoodsPreview.vue?vue&type=script&lang=js&"
export * from "./CategoryGoodsPreview.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGoodsPreview.vue?vue&type=style&index=0&id=b89df5a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89df5a0",
  null
  
)

export default component.exports